import { Capacitor } from "@capacitor/core";
import { BundleInfo, CapacitorUpdater } from "@capgo/capacitor-updater";
import { AppVersion } from "./version";
import * as LocalStore from "./LocalStore";
import { getNewVersionFromServer } from "./API";
import { App } from "@capacitor/app";

let downloadedVersion: BundleInfo | null = null;

export function registerCodePushListener() {
  console.log("[code-push] CURRENT VERSION IS ", AppVersion);
  console.log("[code-push] registering listener");
  if (!Capacitor.isNativePlatform()) {
    console.log("[code-push] skipping. not native platform");
    return;
  }

  if (!Capacitor.isPluginAvailable("CapacitorUpdater")) {
    console.log("[code-push] skipping. plugin not available");
    return;
  }

  CapacitorUpdater.notifyAppReady();

  CapacitorUpdater.addListener("downloadComplete", async (event) => {
    console.log("[code-push] download completed, saving version: " + event.bundle.version);
    downloadedVersion = event.bundle;
    const appState = await App.getState();
    if (!appState.isActive) {
      console.log("[code-push] app is not active, setting version now");
      CapacitorUpdater.set(downloadedVersion);
      downloadedVersion = null;
    }
  });

  attemptToSync({ isActive: true });

  return App.addListener("appStateChange", ({ isActive }) => {
    attemptToSync({ isActive });
  });
}

async function attemptToSync({ isActive }: { isActive: boolean }) {
  if (isActive) {
    const apiConfig = await LocalStore.loadAPIConfig();
    console.log("[code-push] attemptToSync, AppVersion: ", AppVersion);

    const response = await getNewVersionFromServer(apiConfig);

    if (!response.shouldUpdate) {
      console.log("[code-push] No new version to download");
      return;
    }

    if (downloadedVersion !== null && downloadedVersion.version === response.newVersionString) {
      console.log("[code-push] downloaded version is the same as the server version, skipping");
      return;
    }

    CapacitorUpdater.download({
      url: response.downloadUrl,
      version: response.newVersionString,
    });
  } else {
    if (downloadedVersion) {
      console.log("[code-push] app is not active, setting version now");
      CapacitorUpdater.set(downloadedVersion);
      downloadedVersion = null;
    }
  }
}
